import * as React from 'react';
import { inject } from 'mobx-react';
import './tester.scss';
import { withRouter, RouteComponentProps, RouteProps } from 'react-router';
import DataStore from '../../store/DataStore';
import classNames from 'classnames';

interface ITester {
  id: string;
  finished: boolean;
  firstname: string;
  lastname: string;
  dataStore: DataStore;
}

const Tester: React.SFC<RouteComponentProps<any> & RouteProps & ITester> = ({
  id,
  firstname,
  lastname,
  finished,
  dataStore: { startTest }
}) => (
  <React.Fragment>
    <div
      className="sport c-tester"
      onClick={() => {
        startTest(id);
      }}
    >
      <div
        className={classNames(`c-tester__spaceman`, {
          'is-finished': finished
        })}
      >
        <img src={`/images/svg/space-suit.svg`} />
      </div>
      {/* <div>{finished}</div> */}
      <div className="c-tester__sporter">
        <h3 className="c-tester__name">{firstname}</h3>
        <h3 className="c-tester__family-name">{lastname}</h3>
      </div>
    </div>
  </React.Fragment>
);
export default inject('routing', 'dataStore')(withRouter(Tester));



// WEBPACK FOOTER //
// ./src/containers/testers/components/Tester.tsx